/* Scrolling bar offset script - sets --scrolling-bar-height CSS variable */
(function() {
  function setScrollingBarHeight() {
    var bar = document.querySelector('.scrolling-announcement-bar-section');
    if (!bar) return;
    var height = bar.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--scrolling-bar-height', Math.round(height) + 'px');
  }
  // Run immediately (before DOMContentLoaded) so header doesn't jump
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setScrollingBarHeight);
  } else {
    setScrollingBarHeight();
  }
  window.addEventListener('resize', setScrollingBarHeight);
})();